
import slick from 'jquery_version/slick.js';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'svg.js';
import 'jquery.easing.1.3.js';
import 'Chart.min.js';

$(document).ready(function () {
    $("html,body").animate({ scrollTop: $(this).scrollTop() - 1 }, 10);

    var $window = $(window);
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();
    var footerHeight = $('footer').height();

    /* ==========================================================================
                  * banner slick
      ==========================================================================*/

    $('#banner ul').slick({
        dots: true,
        speed: 500,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear'
    });

    $('#videolist ul').slick({
        dots: true,
        speed: 500,
        fade: true,
        prevArrow: $('#videolist .ltbn'),
        nextArrow: $('#videolist .rtbn'),
        pauseOnFocus: false,
        pauseOnHover: false,
        cssEase: 'linear'
    });

    //youtube stop
    var youtube = document.querySelectorAll(".youtube");
    $('#videolist .ltbn,#videolist .rtbn').on('click', function () {
        for (var i = 0; i < youtube.length; i++) {
            document.querySelectorAll('iframe')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
    });

    $('.store_banner').slick({
        arrows: true,
        dots: false,
        speed: 500,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,

        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    /* ==========================================================================
                  * 縮圖 imgLiquid
      ==========================================================================*/

    $('.in_item1_photo,.in_item_img,.series_photo,.series_detail_photo,.gifts_img,.meber_service_img .pc_use,.meber_service_img .mo_use,.custom_img').imgLiquid();



    /* ==========================================================================
                 * window min-height
     ==========================================================================*/

    var headerHeight = $('header').outerHeight(),
        footerHeight = $('footer').outerHeight();


    /* ==========================================================================
                  * resize
      ==========================================================================*/

    $(window).on('resize', function () {
        $("html,body").animate({ scrollTop: $(this).scrollTop() - 1 }, 10);

        windowHeight = $(window).height();
        footerHeight = $('footer').outerHeight();
        var allHeight = (windowHeight - footerHeight);
        $('main').css({ 'min-height': allHeight });
        if ($(this).width() > 992) {
            $('body,html,.sub_menu').removeAttr("style");
            $('.nav_box').removeClass('open').removeAttr('style');
            $('.header_show .sub_menu.active, .nav_box.mo_menu .menu_list.active').removeClass('active');
            $('footer,.top_btn').removeAttr("style");
            $('.hamburger-menu').removeClass('animate')
        }
    }).resize();

    /* ==========================================================================
                 * 門市據點 store_banner
     ==========================================================================*/

    if ($('.store_banner a').length < 3) {
        $('.store_banner .slick-track').css({ 'margin': 'auto' });
    }

    /* ==========================================================================
                    * region_popup
    ==========================================================================*/

    let region_popup = $('#region_popup');

    region_popup.on('click', (e) => {
        if (e.target.id === 'region_popup' || e.target.className === 'close_btn' || e.target.className === 'cancel_btn') {
            region_popup.stop().fadeOut();
        }
    });

    /* ==========================================================================
                 * index marquee_close
     ==========================================================================*/

    let marquee_close = $('.marquee_close'),
        marquee_box = $('.marquee_box');

    marquee_close.on('click', function () {
        marquee_box.hide();
    });


    /* ==========================================================================
                 * 會員註冊 倒數 registration.php
     ==========================================================================*/

    $('.verification_btn').on('click', function () {
        $(this).hide();
        $('.reciprocal').show();

        let num = 60,
            reciprocal = $('.reciprocal');

        $('.reciprocal span').html(num);
        let timers = setInterval(() => {
            num--;
            $('.reciprocal span').html(num);
            if (num === 0) {
                $('.reciprocal').hide();
                $('.verification_btn').show();
                clearInterval(timers);

            }
        }, 1000);
    });

    /* ==========================================================================
                    * 會籍資料 member_profile.php
    ==========================================================================*/

    let profile = $('#Wrapper').hasClass('members_profile_Page');

    if (profile) {
        var integration_color = 'rgba(191, 154, 11, 1)', //目前的點數顏色
            total_points_color = 'rgba(238, 238, 237, 1)'; //總積分顏色 

        var data = data = {
            datasets: [{
                data: [member_integration, member_total_points],
                backgroundColor: [
                    integration_color, total_points_color,
                ],
                hoverBackgroundColor: [
                    integration_color, total_points_color,
                ],
                borderWidth: 0,
                hoverBorderWidth: 0
            }],
        };

        // And for a doughnut chart
        var myDoughnutChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: {
                tooltips: {
                    enabled: false
                },
                cutoutPercentage: 90,
                rotation: - Math.PI * 1,
                circumference: 1 * Math.PI,
                'animation.animateScale': true,
                'animation.animateRotate': false,
            }
        });


        // And for a doughnut chart
        // var myDoughnutChart = new Chart(ctx2, {
        //     type: 'doughnut',
        //     data: data,
        //     options: {
        //         tooltips: {
        //             enabled: false
        //         },
        //         cutoutPercentage: 90,
        //         rotation: - Math.PI * 1,
        //         circumference: 1 * Math.PI,
        //         'animation.animateScale': true,
        //         'animation.animateRotate': false,
        //     }
        // });
    };

    /* ==========================================================================
                    * 會員購買紀錄 開合 member_profile.php
    ==========================================================================*/

    let purchase_btn = $('.purchase_record .membership_box>ul>li');
    purchase_btn.on('click', function (e) {
        e.stopPropagation();
        if (!$(this).hasClass('active')) {
            purchase_btn.removeClass('active');
            purchase_btn.children('.record_detail').stop().slideUp();
            $(this).addClass('active');
            $(this).children('.record_detail').stop().slideDown();
        } else {
            $(this).removeClass('active');
            $(this).children('.record_detail').stop().slideUp();
        }
    });

    /* ==========================================================================
                    *  次選項左右切換 about.php
    ==========================================================================*/

    $('.item_menu_Box').map(function () {
        if (this.offsetWidth < this.scrollWidth) {
            $('.item_Menu').addClass('open_flexslider');
            $('.office_tag').addClass('open_arrw')
        }
    });

    var item_btn =
        '<ul class="flex-direction-nav">' +
        '<li class="fle_l"><span class="mo_mark"></span><a class="flex-prev flex-disabled" href="javascript:;">Previous</a></li>' +
        '<li class="fle_r"><span class="mo_mark"></span><a class="flex-next flex-disabled" href="javascript:;">Next</a></li>' +
        '</ul>';
    $(".office_tag").append(item_btn);

    // slider
    function slider_list() {
        var move = new Array();
        var total_width = 0;
        var i = 0;
        var sum = 0;
        var total = $(".slides li");
        var active = $(".slides li").index($(".slides .active"));

        total_width = $(".slides").width();
        total.each(function () {
            move[i] = $(this).width();
            sum += move[i];
            i++;
        });
        sum = Math.round((total_width - sum) / i);
        for (var j = 0; j < i; j++) move[j] += sum;
        sum = 0;
        for (var ac = 0; ac < active; ac++) sum += move[ac];

        if ($('.item_Menu').hasClass('open_flexslider')) {
            var item_w = $(".item_menu_list").width();
            var list_width = $('.item_Menu').width();
            $('.item_menu_Box').css('width', item_w);
            sum = sum > (total_width - list_width) ? (total_width - list_width) : sum;
            if (active > 0) $('.slides').stop().animate({ left: sum * -1 }, 0);

            //click
            var j = 0;
            var move_total = 0;
            for (var ac = 0; ac <= active; ac++) {
                move_total = ac > 0 ? (move_total + move[ac - 1]) : 0;
                if (move_total > (total_width - list_width)) move_total = (total_width - list_width);
                else j = ac;
            }
            (ac - j) > 1 ? j++ : "";

            $(".flex-next").on('click', function () {
                if (move_total < (total_width - list_width)) {
                    j++;
                    move_total = 0;
                    for (var k = 0; k < j; k++) move_total += move[k];
                    move_total = move_total > (total_width - list_width) ? (total_width - list_width) : move_total;
                    if (j < i) $('.slides').stop().animate({ left: move_total * -1 }, 700);
                }
            });
            $(".flex-prev").on('click', function () {
                if (move_total > 0) {
                    j--;
                    move_total = 0;
                    for (var k = 0; k < j; k++) move_total += move[k];
                    move_total = move_total > (total_width - list_width) ? (total_width - list_width) : move_total;
                    if (j >= 0) $('.slides').stop().animate({ left: move_total * -1 }, 700);
                }
            });
        } else {
            $('.item_Menu').removeClass('open_flexslider');
            $(".slides").scrollLeft(sum);
        }
    }
    slider_list();

    /* ==========================================================================
                  * 人才招募 recruit.php
      ==========================================================================*/

    let rebtn = $('.recruit_title'),
        recruit_content = $('.recruit_content');
    rebtn.on('click', function () {
        let $this = $(this);
        if (!$(this).hasClass('active')) {
            rebtn.removeClass('active');
            $(this).addClass('active');
            recruit_content.stop().slideUp();
            $(this).next().stop().slideDown();
        } else {
            $(this).removeClass('active');
            $(this).next().stop().slideUp();
        }
    });

    /* ==========================================================================
                  * menu開啟
      ==========================================================================*/

    $(window).on('scroll', function () {
        if ($(this).width() > 992) {
            //選單關閉
            $('.nav_box.pc_menu .sub_menu').stop().fadeOut(function () {
                $('.nav_box.pc_menu .sub_menu').removeAttr('style');
            });
        }
    });

    $('.pc_menu nav li').on('mouseenter', function () {

        $(this).children('.sub_menu').prev('a').addClass('active');
        $(this).children('.sub_menu').stop().fadeIn();

    });

    $('.pc_menu nav li').on('mouseleave', function () {

        $(this).children('.sub_menu').stop().fadeOut(400, () => {
            $(this).children('.sub_menu').removeAttr('style');
        });
        $(this).children('.sub_menu').prev('a').removeClass('active');
    });

    /* ==========================================================================
                  * header menu
      ==========================================================================*/

    $('.menu-wrapper').on('click', function () {
        if (!$('.hamburger-menu').hasClass('animate')) {
            $('.hamburger-menu').addClass('animate');
            $('.mo_menu').stop().slideDown().addClass('open');
            $('body,html').css({ 'overflow': 'hidden' });
            $('footer').css({ 'display': 'none' });
            $('.top_btn').css({ 'z-index': '-1' });

        } else {
            $('.hamburger-menu').removeClass('animate');
            $('footer,.top_btn').removeAttr("style");
            $('.mo_menu').stop().slideUp().removeClass('open');
            $('body,html,.sub_menu').removeAttr("style");
            $('.product_bottom').removeClass('active').removeAttr('style');
        }
    });

    /* ==========================================================================
                  * header mobile menu
      ==========================================================================*/
    var mobile_open = $('.mo_menu .mobile_open'),
        menu_back_title = $('.menu_back_title'),
        menu_list_title = $('.menu_list_title'),
        menu_title = $('.menu_title'),
        menu_wrapper = $('.menu-wrapper');

    mobile_open.on('click', function () {
        $(this).next().addClass('active');
        menu_wrapper.hide();
    });

    menu_back_title.on('click', function () {
        $(this).parent('.sub_menu').removeClass('active');
        menu_wrapper.show();
    });

    menu_title.on('click', function () {
        $(this).next().addClass('active');

    });

    menu_list_title.on('click', function () {
        $(this).parent('.menu_list').removeClass('active');
    });


    /* ==========================================================================
                  * Top & header
      ==========================================================================*/
    $(".top_btn").click(function () {
        $("html,body").animate({ scrollTop: 0 }, 600, 'easeInSine');
        return false;
    });

    $window.on('scroll', function () {
        let pos = $(window).scrollTop(),
            scrollTop = $(this).scrollTop(),
            top = $('.top_btn'),
            $_header = $('.header_show'),
            screenHeight = $(window).height(),
            scrollTop2 = $(this).scrollTop() + (screenHeight / 2);


        if (scrollTop > 200) {
            $_header.addClass('head_show');
        }
        if (scrollTop <= 150) {
            $_header.removeClass('head_show');
        }

        if (scrollTop >= 100) {
            top.addClass('active');
        } else {
            top.removeClass('active');
        }

        let top_number;

        if ($(this).width() >= 1024) {
            top_number = 500;
        } else {
            top_number = 300;
        }


        if (scrollTop2 >= $('footer').offset().top - top_number) {
            top.addClass('fix');
        } else if (scrollTop2 <= $('footer').offset().top + 600) {
            top.removeClass('fix');
        }
    });

});